// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1zEpp","abort":"style_abort__1KztN","submit":"style_submit__1-ExT"};